import { NgModule, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getActionTypeFromInstance, NgxsModule } from '@ngxs/store';
import { UsersState } from './users/users.state';
import { ChallengersState } from './challengers/challengers.state';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AwsResourcesState } from './iac/resources/aws/aws-resources.state';
import { AzureResourcesState } from './iac/resources/azure/azure-resources.state';
import { PreferencesFiltersState } from "./preferences/filters/preferences-filters.state";
import { PreferencesExportsState } from "./preferences/exports/preferences-exports.state";
import { IacRepositoriesState } from './iac/repository/gitlab/iac-repositories.state';
import { CicdRepositoriesState } from './cicd/repository/gitlab/cicd-repositories.state';
import { IacRepositoriesGithubState } from './iac/repository/github/iac-repositories.state';
import { CicdRepositoriesGithubState } from './cicd/repository/github/cicd-repositories.state';
import { TfModulesState } from './iac/factorisation/tfmodules.state';
import { CicdFactorisationsState } from './cicd/factorisation/cicd-factorisations.state';
import { VsphereResourcesState } from './iac/resources/vsphere/vsphere-resources.state';
import { ImpervaResourcesState } from './iac/resources/imperva/imperva-resources.state';
import { EntraIdResourcesState } from './iac/resources/entra-id/entra-id-resources.state';
import { GcpResourcesState } from './iac/resources/gcp/gcp-resources.state';
import { FinOpsAwsAccountsState } from './finops/aws/finops-aws-accounts/finops-aws-accounts.state';
import { FinOpsAwsServicesState } from './finops/aws/finops-aws-services/finops-aws-services.state';
import { FinOpsAwsResourcesState } from './finops/aws/finops-aws-resources/finops-aws-resources.state';
import { FinOpsAwsOnOffResourcesState } from './finops/aws/finops-aws-on-off/finops-aws-on-off.state';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { MetaState } from './meta/meta.state';
import { FinOpsContextState } from './finops/context/finops-context.state';
import { SetDuration, SetError, SetStatus, SetTTL, UpdateTimestamp } from './meta/meta.actions';
import { FinOpsAzureSubscriptionsState } from './finops/azure/finops-azure-subscriptions/finops-azure-subscriptions.state';
import { FinOpsAzureServicesState } from './finops/azure/finops-azure-services/finops-azure-services.state';
import { FinOpsAzureResourcesState } from './finops/azure/finops-azure-resources/finops-azure-resources.state';
import { PreferencesProvidersState } from './preferences/providers/preferences-providers.state';
import { PreferencesFinopsState } from './preferences/finops/preferences-finops.state';
import { PreferencesChartsState } from './preferences/charts/preferences-charts.state';
import { PreferencesDashboardState } from './preferences/dashboard/preferences-dashboard.state';


@NgModule({ declarations: [],
    exports: [
        NgxsModule
    ], imports: [CommonModule,
        NgxsModule.forRoot([
            UsersState,
            ChallengersState,
            AwsResourcesState,
            AzureResourcesState,
            PreferencesFiltersState,
            PreferencesExportsState,
            IacRepositoriesState,
            CicdRepositoriesState,
            IacRepositoriesGithubState,
            CicdRepositoriesGithubState,
            TfModulesState,
            CicdFactorisationsState,
            VsphereResourcesState,
            ImpervaResourcesState,
            EntraIdResourcesState,
            GcpResourcesState,
            FinOpsContextState,
            FinOpsAwsAccountsState,
            FinOpsAwsServicesState,
            FinOpsAwsResourcesState,
            FinOpsAwsOnOffResourcesState,
            MetaState,
            FinOpsAzureSubscriptionsState,
            FinOpsAzureServicesState,
            FinOpsAzureResourcesState,
            PreferencesProvidersState,
            PreferencesFinopsState,
            PreferencesChartsState,
            PreferencesDashboardState
        ], {
            developmentMode: isDevMode(),
            selectorOptions: {} // empty object to test option merging
        }),
        NgxsReduxDevtoolsPluginModule.forRoot({
            disabled: !isDevMode(),
            trace: isDevMode()
        }),
        NgxsLoggerPluginModule.forRoot({
            disabled: !isDevMode(),
            filter: (action, state) => {
                // Do not log Meta Service to avoid spam
                return ![UpdateTimestamp.type, SetStatus.type, SetError.type, SetTTL.type, SetDuration.type].includes(getActionTypeFromInstance(action)!);
            }
        })], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class StoreModule { }
